import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
export var VariantEnum;
(function (VariantEnum) {
    VariantEnum["indeterminate"] = "indeterminate";
    VariantEnum["determinate"] = "determinate";
    VariantEnum["buffer"] = "buffer";
    VariantEnum["query"] = "query";
})(VariantEnum || (VariantEnum = {}));
var ColorEnum;
(function (ColorEnum) {
    ColorEnum["primary"] = "primary";
    ColorEnum["secondary"] = "secondary";
})(ColorEnum || (ColorEnum = {}));
var ProgressIndicator = function (_a) {
    var _b = _a.color, color = _b === void 0 ? ColorEnum.primary : _b, _c = _a.variant, variant = _c === void 0 ? VariantEnum.indeterminate : _c, className = _a.className, classes = _a.classes, value = _a.value, valueBuffer = _a.valueBuffer;
    return (React.createElement(LinearProgress, { color: color, variant: variant, className: className, classes: classes, value: value, valueBuffer: valueBuffer }));
};
export default ProgressIndicator;
//# sourceMappingURL=ProgressIndicator.js.map